import React, {Component} from "react";
import NextArrow from "@common-images/nextArrow.svg";
import NextArrowMob from "@common-images/nextArrowMob.svg";

export default class NextBtn extends Component {

  clickHandler = () => {

      localStorage.setItem('duration', 'forward')
      this.props.onClick()
  }



  render() {
    var disabled = this.props.disabled;
    return (
      <button className="btn__next"  disabled={disabled} onClick={this.clickHandler}>
        {this.props.children
            ? this.props.children
            : <>
                <span>Далее</span>
                <div className="btn__arrow">
                    <img src={NextArrow} alt="" />
                </div>
                <div className="btn__arrow-mobile">
                    <img src={NextArrowMob} alt="" />
                </div>
              </>
        }

      </button>
    );
  }
}
